import { appApis } from "../constants";
import reduxKeys from "../constants/reduxKeys";
import HttpClient from "./http-client";

export const getProfile = () => {
    return (dispatch) => {
        new HttpClient().get(`${appApis.getProfile}`).then(response => {
            localStorage.setItem("dealerId", response?.data?.data?.dealerId ?? 0);
            dispatch({ type: reduxKeys.SET_PROFILE, payload: response?.data?.data ?? null });
        }).catch(ex => {
            console.error("Error fetching allowed pages: ", ex);
        });
    };
};